<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <el-form :model="groupDetail" ref="groupDetail" label-width="0px" class="demo-dynamic form-horizontal detailPage">
      <el-tabs type="border-card">
        <el-tab-pane :label="$t('message.' + langItem.langCode)" v-for="(langItem, index) in groupDetail.langMap">
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <h4 class="col-sm-2 control-label">Title<span style="color:red">*</span></h4>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="'langMap.' + index + '.title'"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input v-model="langItem.title" maxlength="50" show-word-limit></el-input>
                  </el-form-item>
                </div>
              </div>
              <!-- <div class="form-group">
                <div class="col-sm-2" style="padding-right: 0px;">
                  <h4 style="padding-top: 20px;text-align: right;">Image <span style="color:red">*</span></h4>
                </div>
                <div class="col-sm-10" style="padding-top: 20px;">
                  <el-form-item
                    prop="imageUrl"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'change',
                    }"
                  >
                    <el-input v-model="langItem.imageUrl" style="display: none"> </el-input>
                    <file-upload :filewidth="1368" :fileheight="800" :type="'aboutUs'" :limit="30" id="image" :image="urlImage" v-model="groupDetail.imageUrl">
                      <template v-slot:sizeError>
                        <div style="color: red">Size error!</div>
                      </template>
                      <template v-slot:dimensionError>
                        <div style="color: red">Dimension Error!</div>
                      </template>
                      <template v-slot:sizeHint>
                        <p style=" margin-bottom: 0px;">Suggested Size: 1368 x 800px</p>
                        Max 30 MB.
                      </template>
                    </file-upload>
                  </el-form-item>
                </div>
              </div> -->
              <div class="form-group">
                <h4 class="col-sm-2 control-label">Description<span style="color:red">*</span></h4>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="'langMap.' + index + '.description'"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <ckeditor :editor="editor" @ready="onReady" v-model="langItem.description" :config="editorConfig"></ckeditor>
                    <el-input style="display:none" v-model="langItem.title"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <div class="form-group">
          <div class="col-sm-12">
            <div class="pull-right">
              <el-button @click="checkEvent">{{ $t("message.Save") }}</el-button>
              <el-button @click="goBack">{{ $t("message.Cancel") }}</el-button>
            </div>
          </div>
        </div>
      </el-tabs>
    </el-form>
  </div>
</template>
<script>
import config from "../config";
import ClassicEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import fileupload from "../components/common/fileupload";
export default {
  mixins: [config.globalMixin],
  components: {
    "file-upload": fileupload,
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: ["fontColor", "bold", "italic", "underline", "Link", "insertTable"],
      },
      groupDetail: {
        imageUrl: "",
        langMaps: [{ langCode: "en_US" }, { langCode: "zh_CN" }, { langCode: "zh_HK" }],
      },
      urlImage: "",
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      let obj = this.getAuthObj();
      obj.apiUrl = this.apiConfig.aboutUsDetail;
      let data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      data.data.result.langMap = this.langMapObject(data.data.result.langMaps);
      this.urlImage = await this.getImgrul().url.imageUrl;
      this.$set(this, "groupDetail", data.data.result);
    },
    goBack() {
      this.$router.push({
        path: "/main/homePageController",
      });
    },
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui.getEditableElement().parentElement.insertBefore(editor.ui.view.toolbar.element, editor.ui.getEditableElement());
    },
    checkEvent() {
      this.$refs["groupDetail"].validate(valid => {
        if (valid) {
          this.submit();
        } else {
          this.$toastr.w(this.$i18n.t("message.fillRequired"));
          return false;
        }
      });
    },
    async submit() {
      let obj = this.getAuthObj();
      var langMaps = [];
      this.groupDetail.langMap.forEach(item => {
        langMaps.push({
          langCode: item.langCode,
          description: item.description,
          title: item.title,
        });
      });
      obj.langMap = langMaps;
      obj.imageUrl = this.groupDetail.imageUrl;
      var data;
      obj.apiUrl = this.apiConfig.aboutUsSave;
      data = await this.$store.dispatch("apiEvent", obj);
      if (data.data.errorCode == "0000") {
        this.$message({
          showClose: true,
          message: "success",
          type: "success",
        });
      }
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$store.state.edit = false;
      this.init();
    },
  },
};
</script>
<style>
.el-upload__input {
  display: none !important;
}
</style>
